import {   FETCH_ACTIVE_SEASONS,SAVE_SEASON_PARTICIPANT,TRIGGER_SEASON,RESET_PARTICIPANT_SETTINGS } from '../../actions'

function getParticipantSettings(seasons){
       
        const seasonparticipants = {}
      
        seasons.map(function(season) {
            const { id,maxNumberBowlersPerEvent,maxNumberBowlersPerSeason,maxNumberNcaaTeams,maxNumberNonNcaaTeams,minMenTeams,minWomenTeams,maxNumberTeamAthletesPerEvent,minNumberTeamAthletesPerEvent,rosterMaxFirstSemester,rosterMaxSecondSemester ,isSeasonSet } = season
            const seasonparticipant = {
                seasonId: id,
                maxNumberBowlersPerEvent,
                maxNumberBowlersPerSeason,
                maxNumberNcaaTeams,
                maxNumberNonNcaaTeams,
                minMenTeams,
                minWomenTeams,
                maxNumberTeamAthletesPerEvent,
                minNumberTeamAthletesPerEvent,
                rosterMaxFirstSemester,
                rosterMaxSecondSemester, 
                isSeasonSet
            }
            seasonparticipants[id] = seasonparticipant
        })
        return seasonparticipants
}
function getSingleParticipantSettings(season){
    
        const { id,maxNumberBowlersPerEvent,maxNumberBowlersPerSeason,maxNumberNcaaTeams,maxNumberNonNcaaTeams,minMenTeams,minWomenTeams,maxNumberTeamAthletesPerEvent,minNumberTeamAthletesPerEvent,rosterMaxFirstSemester,rosterMaxSecondSemester } = season
        const seasonparticipant = {
            seasonId: id,
            maxNumberBowlersPerEvent,
            maxNumberBowlersPerSeason,
            maxNumberNcaaTeams,
            maxNumberNonNcaaTeams,
            minMenTeams,
            minWomenTeams,
            maxNumberTeamAthletesPerEvent,
            minNumberTeamAthletesPerEvent,
            rosterMaxFirstSemester,
            rosterMaxSecondSemester,
            isSeasonSet:true
        }
    
    return seasonparticipant

}     
export default function seasonparticipants (state,action) {   
        const {  payload } = action      
        switch(action.type) {
          
            case FETCH_ACTIVE_SEASONS: {           
                const { data } = payload
                if (data) {                
                    const defaultId = payload.data[0].id
                    const participants = getParticipantSettings(data)
                    const initialstate = participants
                    return Object.assign({},state,{
                            values: {
                                participants,
                                settingsseason:defaultId,
                                initialstate
                            },
                            fields: {
                                participants,
                                settingsseason:defaultId,
                                initialstate
                            }
                        }
                    )
                }
                else {
                    return state
                }
            }
            case SAVE_SEASON_PARTICIPANT: {
                const datasaved  = true 
                const savingdata = false
                return  { ...state, 
                    values: {
                             ...state.values,
                             savingdata,
                             datasaved,
                             initialstate:state.values.participants         
                           },
                    fields: {
                             ...state.fields,
                             savingdata,
                             datasaved,
                             initialstate:state.values.participants  
                           }
                 }
                 
            }
            case TRIGGER_SEASON: {
                const seasontriggered = true 
                const isSettingSeason = false
              
                const seasonparticipants  = getSingleParticipantSettings(payload.data)
               
                const seasonId  = seasonparticipants.seasonId
                const { participants } = state.values
                participants[seasonId] = seasonparticipants
               
                return  { ...state, 
                   values: {
                             ...state.values ,
                             seasontriggered,
                             isSettingSeason ,
                             participants                          
                           },
                   fields: {
                             ...state.fields,
                             seasontriggered,
                             isSettingSeason,
                             participants   
                           }
                 }
               
            }
            case RESET_PARTICIPANT_SETTINGS:{
             
                const { initialstate } = state.values
              
                return  { ...state, 
                    values: {
                             ...state.values,
                             participants:initialstate,
                             participantreset:true
                           },
                    fields:{
                             ...state.fields,
                             participants:initialstate,
                             participantreset:true
                           }
                 }
            }
            default: return state
        }
}


// WEBPACK FOOTER //
// ./src/redux/reducers/forms/seasonparticipants.js